import { STATUS_BUSY, STATUS_ERROR, STATUS_STEP } from '../actions/status.js'

export default function status(state, action) {
	switch (action.type) {
		case STATUS_BUSY: {
			return { ...state, busy: action.payload, error: null }
		}

		case STATUS_ERROR: {
			return { ...state, busy: false, error: action.payload }
		}

		case STATUS_STEP: {
			return { ...state, step: action.payload }
		}

		default: {
			return state
		}
	}
}
